import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Input, Select } from 'components/ui';
import { Collapse } from '@mui/material';
import * as Styled from './Additional.styles';

export const Additional = ({ form }) => {
  const { values, errors, setFieldValue } = form;

  return (
    <Styled.Wrapper>
        <Input
            onChange={(value) => setFieldValue('address.commune', value)}
            value={values.address.commune}
            label="Gmina"
            error={(errors.address || {}).commune}
        />

        <Input
            onChange={(value) => setFieldValue('address.county', value)}
            value={values.address.county}
            label="Powiat"
            error={(errors.address || {}).county}
        />

        <Input
            onChange={(value) => setFieldValue('address.voivodeship', value)}
            value={values.address.voivodeship}
            label="Województwo"
            error={(errors.address || {}).voivodeship}
        />
    </Styled.Wrapper>
  );
};

Additional.propTypes = {
  form: PropTypes.object.isRequired,
};
